import { defineComponent, onMounted } from 'vue';
import AuditorEntriesOverview from '@/presentation/components/auditor/auditor-entries-overview.vue';
import AuditorCode from '@/presentation/pages/auditor/auditor.code';

export default defineComponent({
	components: {
		AuditorEntriesOverview
	},
	setup: () => {
		const code = new AuditorCode();

		onMounted(code.mounted.bind(code));

		return { };
	}
});
